import React from 'react'
import styled from 'styled-components'
import { FbIcon, InIcon, TwitterIcon, YoutubeIcon, InstagramIcon, WebsiteIcon } from '@pga/pga-component-library'
import { parseWebsite } from '../../common/utils'

export const SocialBox = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding-top: 5px;
  i {
    padding-left: 0;
  }
`

export const Link = styled.a.attrs({
  target: '_blank',
  rel: 'noreferrer'
})`
`

const socialIcons = {
  facebook: (link, id) => <Link key={id} href={link} ><FbIcon /></Link>,
  linkedin: (link, id) => <Link key={id} href={link} ><InIcon /></Link>,
  twitter: (link, id) => <Link key={id} href={link} ><TwitterIcon /></Link>,
  youtube: (link, id) => <Link key={id} href={link} ><YoutubeIcon /></Link>,
  instagram: (link, id) => <Link key={id} href={link}><InstagramIcon /></Link>,
  website: (link, id) => <Link key={id} href={parseWebsite(link)}><WebsiteIcon /></Link>
}

const networks = ['facebook', 'linkedin', 'instagram', 'twitter', 'youtube', 'website']

export default ({ social }) => {
  return (
    <SocialBox>
      {networks.map((item, i) => social[item] && socialIcons[item](social[item], i))}
    </SocialBox>
  )
}
